import { render, staticRenderFns } from "./FundingReports.vue?vue&type=template&id=3fab0cc2&scoped=true"
import script from "./FundingReports.vue?vue&type=script&lang=js"
export * from "./FundingReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fab0cc2",
  null
  
)

export default component.exports